(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camelie-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('camelie-looks')) {
    customElements.define(
      'camelie-looks',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;

          this.querySelectorAll('.cl-dot').forEach(dot => {
            dot.setAttribute('role', 'button');
            dot.setAttribute('aria-expanded', 'false');

            dot.addEventListener('keydown', event => {
              if (event.key === ' ') {
                event.preventDefault();
                dot.click();
              }
            });
          });

          this.addEventListener('click', event => {
            const dot = event.target.closest('.cl-dot');

            if (dot) {
              const panel = document.getElementById(dot.dataset.panel);

              if (!panel) return;

              event.preventDefault();

              const open = panel.hidden;

              this.closePanels(false);

              panel.hidden = !open;
              dot.setAttribute('aria-expanded', String(open));
            }

            if (event.target.closest('.cl-close')) {
              this.closePanels(true);
            }
          });

          this.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              this.closePanels(true);
            }
          });
        }

        closePanels(restoreFocus) {
          const active = this.querySelector(
            '.cl-dot[aria-expanded="true"]'
          );

          this.querySelectorAll('.cl-panel').forEach(panel => {
            panel.hidden = true;
          });

          this.querySelectorAll('.cl-dot').forEach(dot => {
            dot.setAttribute('aria-expanded', 'false');
          });

          if (restoreFocus && active) {
            active.focus();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-camelie-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('camelie-product')) {
    customElements.define(
      'camelie-product',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;

          const radios = this.querySelectorAll('[data-variant]');

          if (!radios.length) return;

          const update = (radio, updateUrl) => {
            const button = this.querySelector('[data-add-button]');

            this.querySelector('[data-price]').textContent =
              radio.dataset.price;

            const compare = this.querySelector('[data-compare]');

            compare.textContent = radio.dataset.compare;
            compare.hidden = !radio.dataset.compare;

            button.disabled = radio.dataset.available !== 'true';

            button.textContent = button.disabled
              ? this.dataset.sold
              : this.dataset.add;

            const quantity = this.querySelector('[name="quantity"]');
            const min = Number(radio.dataset.min) || 1;
            const step = Number(radio.dataset.step) || 1;

            quantity.min = String(min);
            quantity.step = String(step);

            if (radio.dataset.max) {
              quantity.max = radio.dataset.max;
            } else {
              quantity.removeAttribute('max');
            }

            let amount = Math.max(
              min,
              Number(quantity.value) || min
            );

            amount =
              min + Math.ceil((amount - min) / step) * step;

            if (radio.dataset.max) {
              const max = Number(radio.dataset.max);

              amount = Math.min(
                amount,
                min + Math.floor((max - min) / step) * step
              );
            }

            quantity.value = String(amount);

            if (updateUrl) {
              const url = new URL(window.location.href);

              url.searchParams.set('variant', radio.value);

              window.history.replaceState({}, '', url);
            }
          };

          radios.forEach(radio => {
            radio.addEventListener('change', () => {
              if (radio.checked) {
                update(radio, true);
              }
            });
          });

          const selected = this.querySelector(
            '[data-variant]:checked'
          );

          if (selected) {
            update(selected, false);
          }

          this.querySelector('form').addEventListener(
            'submit',
            event => {
              const radio = this.querySelector(
                '[data-variant]:checked'
              );

              if (
                !radio ||
                radio.dataset.available !== 'true'
              ) {
                event.preventDefault();
              }
            }
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
